import { DEFAULT_CONSENT_STEPS } from './consentJourneyConstants';

const normalizeDeclarations = declarations => {
  if (!Array.isArray(declarations)) return [];
  return declarations.reduce((result, declaration, index) => {
    const item = typeof declaration === 'string' ? { id: `declaration-${index + 1}`, text: declaration } : declaration;
    if (!item || typeof item !== 'object' || typeof item.text !== 'string' || !item.text.trim()) return result;
    const id = String(item.id || `declaration-${index + 1}`).trim();
    if (!id || result.some(existing => existing.id === id)) return result;
    result.push({ id, text: item.text.trim(), required: item.required !== false });
    return result;
  }, []);
};

export const normalizeConsentJourney = (journey, totalMembers) => {
  const config = journey && typeof journey === 'object' ? journey : {};
  const configuredSteps = Array.isArray(config.steps) ? config.steps : DEFAULT_CONSENT_STEPS;
  const packageMemberLimit = Number(totalMembers);
  const maxAdditionalMembers = Number.isFinite(packageMemberLimit) ? Math.max(packageMemberLimit - 1, 0) : 0;
  const stepConfig = key => {
    const step = configuredSteps.find(entry => (typeof entry === 'string' ? entry : entry?.key) === key);
    return step && typeof step === 'object' ? step : {};
  };
  const steps = configuredSteps.reduce((result, step) => {
    const entryConfig = typeof step === 'object' && step !== null ? step : {};
    const stepKey = typeof step === 'string' ? step : entryConfig.key;
    if (!DEFAULT_CONSENT_STEPS.includes(stepKey) || result.includes(stepKey)) return result;
    if (entryConfig.enabled === false) return result;
    if (stepKey !== 'additionalMembers' || maxAdditionalMembers > 0) result.push(stepKey);
    return result;
  }, []);
  const reviewConfig = stepConfig('review');
  const declarations = normalizeDeclarations(reviewConfig.declarations);

  return {
    steps,
    additionalMembersRequired: stepConfig('additionalMembers').required === true,
    maxAdditionalMembers,
    declarationsRequired: reviewConfig.declarationsRequired !== false && declarations.length > 0,
    declarations,
  };
};
